import { useEffect } from "react";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { ReactSetStateFunction } from "@utils/utility-types";
import { CompanyProfileTab } from "@router/route-params";
import { BaseCompanyIdProps } from "@custom-types/base-types";
import { EntityReport } from "@pages/workspace-profile/tab-contents/workspace-info-tab/delete-workspace/delete-workspace-utils";
import { Text } from "@flat-ui";

interface Props extends BaseCompanyIdProps {
  /** Setter for shouldDisableContinueButton */
  setShouldDisableContinueButton: ReactSetStateFunction<boolean>;

  /** Response from delete workspace API */
  deleteWorkspaceResponse?: FaroCoreApiTypes.DeleteCompanyResponse;
}

/** Content for step 1 of delete workspace */
export function DeleteWorkspaceStep1({
  companyId,
  setShouldDisableContinueButton,
  deleteWorkspaceResponse,
}: Props): React.JSX.Element {
  useEffect(() => {
    setShouldDisableContinueButton(false);
  }, [setShouldDisableContinueButton]);

  return (
    <Text variant="bodyM">
      This action is permanent and takes effect immediately. By deleting this
      company, the following data will be removed from the FARO ecosystem:
      <EntityReport
        companyId={companyId}
        tab={CompanyProfileTab.groups}
        label="groups"
        deleteWorkspaceResponse={deleteWorkspaceResponse}
      />
      <EntityReport
        companyId={companyId}
        tab={CompanyProfileTab.projects}
        label="projects"
        deleteWorkspaceResponse={deleteWorkspaceResponse}
      />
      Single members of the workspace will not be deleted. You need to delete
      them separately if needed.
    </Text>
  );
}
